import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑团队为您精选的优质内容</p>
          </div>
          <Link
            to="/category/japanese-culture"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block rounded-lg bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - 亚洲一级日本精选内容`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 1 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-0.5 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-800 whitespace-nowrap">
                    {article.tags[0]}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime} 分钟阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}